(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("5QyMP", function(module, exports) {
const $441ccaf2c88eaf1c$var$accordions = document.querySelectorAll(".i-accordion");
const $441ccaf2c88eaf1c$var$currentUrl = new URL(window.location.href);
if ($441ccaf2c88eaf1c$var$currentUrl.searchParams.has("group")) {
    const urlTargetId = $441ccaf2c88eaf1c$var$currentUrl.searchParams.get("group");
    const targetAccordion = document.querySelector(`#${urlTargetId}`);
    if (targetAccordion) {
        if (!targetAccordion.classList.contains("--toggled")) targetAccordion.classList.add("--toggled");
        targetAccordion.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }
}
$441ccaf2c88eaf1c$var$accordions.forEach((accordion)=>{
    const accordionHeader = accordion.querySelector(".i-accordion__header");
    const accordionId = accordion.id;
    accordionHeader?.addEventListener("click", ()=>{
        if (accordionId) $441ccaf2c88eaf1c$var$currentUrl.searchParams.set("group", `${accordionId}`);
        else if ($441ccaf2c88eaf1c$var$currentUrl.searchParams.has("group")) $441ccaf2c88eaf1c$var$currentUrl.searchParams.delete("group");
        window.history.pushState({}, "", $441ccaf2c88eaf1c$var$currentUrl.toString());
    });
});

});

})();
//# sourceMappingURL=accordions-group.8d0e3ad3.js.map
